import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

import GameContainer from './GameContainer.js';

import WordSearchCanvas from '../games/WordSearchCanvas_new.js';
import { getSoundPropsById } from '../../lib/ep.js';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';


const Instructions = (props) => {
	return null;
};

const Legend = ({ stage, ...props }) => {
	const display_legend = stage?.display_legend ?? true;

	if(display_legend === false) return null;

	return (
		<aside class="gui_legend gui_main_text_color_on_bg">
			{(stage?.wordsearch_words ?? []).map((word, i) => {
				const classes = ['tip_label', 'cutTextOnOverflow'];
				if((props?.found ?? []).includes(word)) classes.push('is_done');

				return (
					<span key={i} class={classes.join(" ")}>{word}</span>
				)
			})}
		</aside>
	)
};

const WordSearchClient = ({ stage, ...props }) => {
	const [ found_words, setFoundWords ] = useState([]);

	const sound_fx = {
		selecting:new Howl({ ...getSoundPropsById('bubbles') }),
		error:new Howl({ ...getSoundPropsById('error_backflip') }),
		found:new Howl({ ...getSoundPropsById('success') }),
		success:new Howl({ ...getSoundPropsById('applause') }),
		fail:new Howl({ ...getSoundPropsById('fail') }),
	};

	const onFound = (w) => {
		const _fw = [ ...found_words ];
		_fw.push(w);
		setFoundWords(_fw);
	};

	const onResetFounds = () => {
		setFoundWords([]);
	};

	const final_stage = clientFinalPage(stage, props.actual_state);

	return (
		<GameContainer
			{...props}
			stage={final_stage}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			legend={<Legend
				stage={stage?.Stage}
				intl={props.intl}
				found={found_words}
			/>}
			game_type="wordsearch"
			auto_start_timer={false}
			display_audio_controls={true}
			instructions_has_border={false}
			instructions_classes='gui_flex_align_center'
			sound_fx={sound_fx}
		>
			{((stage.Stage?.wordsearch_words ?? []).length > 2) ? (
				<WordSearchCanvas
					onFound={onFound}
					onResetFounds={onResetFounds}
				/>
			) : (
				<MisconfiguredGameWarning
					message="Start adding some words to generate the word search grid"
				/>
			)}
		</GameContainer>
	)
};

export default injectIntl(WordSearchClient);